// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606220803/js/" + chunkId + "." + {"44":"181ea194","225":"f556231b","481":"60ba8b87","486":"ee9be73d","770":"5e9c5f95"}[chunkId] + ".0.23706189413586443.chunk.js";
};